const InterfaceConstructor = require("../template")
const onmessage = new InterfaceConstructor("onmessage")

onmessage.methods = {
    // MicroPhone Permission Default Callbacks
    microphonePermissionSuccess: () => {},
    microphonePermissionFailure: () => {},
    // Camera Permission Default Callbacks
    cameraPermissionSuccess: () => {},
    cameraPermissionFailure: () => {},
    // Location Permission Default Callbacks
    locationPermissionSuccess: () => {},
    locationPermissionFailure: () => {},
    // Screen Share Permission Default Callbacks
    screenSharePermissionSuccess: () => {},
    screenSharePermissionFailure: () => {},
}

module.exports = onmessage
